import { Component, AfterViewInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoadingController, NavController, IonRouterOutlet, ModalController } from '@ionic/angular';
import { CreateMatchComponent } from '../matches/create-match/create-match.component';
import { MatchService } from '../_core/services/match.service';
import { ToastService } from '../_core/services/toast.service';
import { Match } from '../_shared/models/match.model';

@Component({
  standalone: false,
    selector: 'app-share',
    templateUrl: './share.page.html',
    styleUrls: ['./share.page.scss'],
})
export class SharePage implements AfterViewInit, OnDestroy {
    loading: HTMLIonLoadingElement;

    constructor(
        private route: ActivatedRoute,
        private loadingController: LoadingController,
        private navCtrl: NavController,
        private modalController: ModalController,
        private routerOutlet: IonRouterOutlet,
        private matchService: MatchService,
        private toast: ToastService,
    ) { }

    ngAfterViewInit(): void {
        this.presentLoading();
        this.handleNavParams();
    }

    ngOnDestroy(): void {
        this.loading.dismiss();
    }

    private handleNavParams() {
        const params = { ...this.route.snapshot.queryParams };

        // share?create=true&partner={PARTNER}&code={CODE}
        if (params.create && JSON.parse(params.create)) {
            this.openCreateMatchModal(params.partner, params.code);
            // this.navCtrl.navigateRoot('');
        }

        // share?changeTracker=true&matchId={MATCHID}
        else if (params.changeTracker && JSON.parse(params.changeTracker)) {
            const matchId = params.matchId;
            this.matchService
                .changeTracker(matchId)
                .subscribe(
                    res => {
                        const match: Match = res.data;
                        this.toast.presentToast(res.message);
                        if (match.tie) {
                            this.navCtrl.navigateRoot(`ties/${match.tie}`);
                        } else {
                            this.navCtrl.navigateRoot(`live-scoring/${match._id}`);
                        }
                    },
                    err => {
                        this.navCtrl.navigateRoot('');
                    }
                );
        }
    }

    async openCreateMatchModal(partner?, code?) {
        const modal = await this.modalController.create({
            component: CreateMatchComponent,
            componentProps: {
                partner: partner,
                code: code
            },
            id: 'create-match-modal',
            presentingElement: this.routerOutlet.nativeEl
        });

        await modal.present();

        const { data } = await modal.onDidDismiss();

        this.navCtrl.navigateRoot('');
    }

    async presentLoading() {
        this.loading = await this.loadingController.create({
            message: 'Fetching',
            spinner: 'bubbles'
        });
        await this.loading.present();
    }


}
